import { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { onSnapshot, collection, query } from 'firebase/firestore'

import { database }  from '../services/firebase'

import { AuthContext } from '../App';

import { Header } from '../components/header'

import styles from '../styles/pages/servicosDisponiveis.module.scss'

export function AcontecemAqui() {
    const { user, userSettings } = useContext<any>(AuthContext)
    const [list, setList] = useState<any | null>([])

    const params = useParams()

    useEffect(() => {
        const q = query(collection(database, "acontecemAqui"))

        let isMounted = true 

        if(isMounted) {
            onSnapshot(q, (querySnapshot) => {
                const items: any = [];
                
                querySnapshot.forEach((doc) => {
                    if(doc.id == params.id){
                        items.push({ id: doc.id, ...doc.data() })
                    }
                });
    
                setList(items)
    
                return items
            })
        }
        
        return () => {
            isMounted = false
        }
    }, [])

    return (
        <>
            <div className={`${ styles.content } ${ styles.contentAdmin } ${ userSettings?.type }`}>
                <Header />

                <div className={styles.dashboardHolder}>
                    <div className={styles.servicosDisponiveisDescription}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                            <span>/acontece aqui</span>

                            <Link 
                                to="/acontece-aqui" 
                                style={{ 
                                    background: '#fff', 
                                    textDecoration: 'none',  
                                    display: 'inline-block' , color: '#000',
                                    padding: '5px 10px',
                                    borderRadius: 20
                                }}>
                                    voltar
                            </Link>
                        </div>

                        {list.map((item: any) => {
                            return (
                                <div key={item.id} className={styles.dashboardHolder}>
                                    <div className={styles.servicosDisponiveisDescription}>
                                        <div className={styles.thumb}>
                                            <img src={item.imageUrl} alt="" />
                                        </div>

                                        <div className={styles.descriptionServices}>
                                            <div className={styles.titleServices}>
                                                <span>{item.titulo}</span>
                                                <p><strong>{item.subtitulo}</strong></p>

                                                <p><strong>{item.local}</strong></p>
                                                <p>{item.descricao}</p>
                                            </div>
                                        </div>

                                        { item?.link &&
                                            <div className={styles.servicesButton}>
                                                <a href={item.link} target="_blank">Acesse o site oficial</a>
                                            </div>
                                        }
                                    </div>  
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

        </>
    )
}